import styled, { css } from 'styled-components';

type props = {
    highlightCallout?: boolean
}

const Callout = styled.div<props>`
    ${({ highlightCallout }) => highlightCallout && css`
        margin: ${({ theme }) => `${theme.Spacing.spacing4x} ${theme.Spacing.spacing0x} ${theme.Spacing.spacing4x}`};

        &::before {
            content: '';
            position: fixed;
            background-color: #F4F4F4;
            left: 0;
            right: 0;
            z-index: -1;
            margin-top: ${({ theme }) => `-${theme.Spacing.spacing2x}`};
            padding-top: ${({ theme }) => theme.Spacing.spacing7x};
        }
    `}
`;

export default Callout;
